<script lang="ts">
  import { _ } from "svelte-i18n";
  import { bridge } from "./lib/bridge";
  import mascotImg from "./assets/not-found.png";

  function handleGoBack() {
    bridge.callNative("toClose");
  }
</script>

<main class="h-full flex flex-col bg-[var(--bg-Color-group-1)]">
  <!-- header -->
  <div
    class="h-44 text-[20px] font-semibold px-[16px] flex flex-col justify-center items-center relative min-h-44 shrink-0"
  >
    <div
      class="absolute left-[16px] inset-y-0 my-auto size-24 flex items-center justify-center cursor-pointer"
      onclick={handleGoBack}
      role="button"
      tabindex="0"
      onkeydown={(e) => e.key === "Enter" && handleGoBack()}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.22437 12.7008C1.90402 12.2644 1.92662 11.621 2.29273 11.2142L10.2927 2.32556C10.6833 1.89166 11.3163 1.89166 11.7068 2.32556C12.0973 2.75947 12.0973 3.4628 11.7068 3.89671L4.41383 11.9998L11.7068 20.1029C12.0973 20.5368 12.0973 21.2402 11.7068 21.6741C11.3163 22.108 10.6833 22.108 10.2927 21.6741L2.29273 12.7854L2.22437 12.7008Z"
          fill="var(--text-text-h1)"
        />
      </svg>
    </div>
  </div>

  <!-- content -->
  <div class="flex-1 flex flex-col items-center justify-start pt-[116px]">
    <img
      src={mascotImg}
      alt="coming soon"
      class="w-[240px] h-[189px] object-contain"
    />
    <p
      class="mt-[8px] text-[16px] font-semibold text-[var(--text-text-h2)] leading-[24px]"
    >
      {$_("coming_soon_desc")}
    </p>
  </div>

  <!-- bottom button -->
  <div
    class="shrink-0 px-[16px] py-[12px] border-t border-[var(--divider-color-2)]"
  >
    <button
      class="w-full h-44 rounded-[22px] bg-[var(--button-primary-bg-default)] text-[16px] font-semibold text-[var(--text-text-reverse1)] leading-[24px] cursor-pointer"
      onclick={handleGoBack}
    >
      {$_("go_back")}
    </button>
  </div>
</main>

<style>
</style>
